import { useSyncExternalStore } from "react";
import {
  getThemePreference,
  setThemePreference,
  subscribeToTheme,
} from "@/lib/theme";
import type { ThemePreference } from "@/lib/theme";

/** The device's Light / Dark / System preference and its setter. See [[theming]]. */
export function useTheme(): {
  preference: ThemePreference;
  setPreference: (next: ThemePreference) => void;
} {
  const preference = useSyncExternalStore(
    subscribeToTheme,
    getThemePreference,
    () => "system" as const,
  );
  return { preference, setPreference: setThemePreference };
}
